"use strict";

var _regeneratorRuntime = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = require("three");

var surface_1 = require("./surface");

var ThreeBSP = require('three-js-csg')(THREE); // TODO - Find an updated plugin and use ES6 import


var modelMemory = [];

exports.bufferGeometryToGeometry = function (bufferGeometry) {
  if (bufferGeometry instanceof THREE.BufferGeometry) {
    return new THREE.Geometry().fromBufferGeometry(bufferGeometry);
  } else {
    return bufferGeometry;
  }
};

exports.calculateOuterRadiusFromObject = function (object) {
  var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var lowest;
  object.traverse(function (child) {
    if (child instanceof THREE.Mesh) {
      if (child.geometry !== undefined) {
        var geometry = exports.bufferGeometryToGeometry(child.geometry);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = geometry.vertices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var vertex = _step.value;

            if (Math.abs(vertex[axis]) !== 0 && (typeof lowest === 'undefined' || lowest < Math.abs(vertex[axis]))) {
              lowest = Math.abs(vertex[axis]);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  });
  var outerRadius = typeof lowest !== 'undefined' ? lowest : 0;
  return outerRadius;
};

exports.loadModel = function (url) {
  return new Promise(function (resolve) {
    if (typeof modelMemory[url] === 'undefined') {
      var loader = new THREE.ObjectLoader(); // TODO - Add a fallback if file not found... at the moment whole application will just crash, but it should work just with a missing object

      loader.load(url, function (object) {
        modelMemory[url] = object;
        resolve(modelMemory[url].clone()); // Removing object ref with JSON stringify + parse
      });
    } else {
      resolve(modelMemory[url].clone());
    }
  });
};

exports.buildElementMeshFromObject = function (object, element, match) {
  var mesh; // Looking through the object to find geometry match...

  object.traverse(function (child) {
    if (child instanceof THREE.Mesh) {
      if (child.geometry !== undefined) {
        if (child.name.search(match) !== -1) {
          var geometry = new THREE.Geometry().fromBufferGeometry(child.geometry);
          mesh = new THREE.Mesh(geometry, surface_1.surface.getMaterial(element.material));
          mesh.position.copy(element.position);
        }
      }
    }
  });
  return mesh;
};

exports.disposeEntity = function (entity) {
  if (typeof entity.geometry !== 'undefined' && typeof entity.material.geometry !== 'undefined') {
    entity.geometry.dispose();
  }

  if (typeof entity.material !== 'undefined' && typeof entity.material.dispose !== 'undefined') {
    entity.material.dispose();
  }

  if (typeof entity.children !== 'undefined') {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = entity.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var child = _step2.value;
        exports.disposeEntity(child);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
};

exports.buildObject = function (element) {
  var folder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var object;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return exports.loadModel("https://kwcws3d.blob.core.windows.net/cdn/models/".concat(folder).concat(element.fileName, ".json"));

          case 2:
            object = _context.sent;
            object.position.copy(element.position);
            object.traverse(function (obj) {
              if (obj instanceof THREE.Mesh) {
                var material = surface_1.surface.getMaterial(element.material);
                obj.material = material;
              }
            });
            return _context.abrupt("return", object);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.buildElementMeshesFromObject = function (object, element, match) {
  var exclusions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var meshes = [];
  object.traverse(function (child) {
    if (child instanceof THREE.Mesh) {
      if (child.geometry !== undefined) {
        if (child.name.search(match) !== -1 && !new RegExp(exclusions.join('|')).test(child.name)) {
          var geometry = new THREE.Geometry().fromBufferGeometry(child.geometry);
          geometry.computeBoundingBox();
          var mesh = new THREE.Mesh(geometry, surface_1.surface.getMaterial(element.material));
          mesh.position.copy(element.position);
          meshes.push(mesh);
        }
      }
    }
  });
  return meshes;
};

exports.subtractMeshFromMesh = function (mainMesh, subtractingMesh) {
  try {
    var mainBsp = new ThreeBSP(mainMesh);
    var subtractingBsp = new ThreeBSP(subtractingMesh);
    var subtracted = mainBsp.subtract(subtractingBsp).toMesh(mainMesh.material);
    return subtracted;
  } catch (e) {
    console.log(e);
  }

  return mainMesh;
};

exports.intersectMeshFromMesh = function (mainMesh, subtractingMesh) {
  var mainBsp = new ThreeBSP(mainMesh);
  var subtractingBsp = new ThreeBSP(subtractingMesh);
  var subtracted = mainBsp.intersect(subtractingBsp).toMesh(subtractingMesh.material);
  return subtracted;
};

exports.unionMeshFromMesh = function (mainMesh, subtractingMesh) {
  var mainBsp = new ThreeBSP(mainMesh);
  var subtractingBsp = new ThreeBSP(subtractingMesh);
  var subtracted = mainBsp.union(subtractingBsp).toMesh(subtractingMesh.material);
  return subtracted;
};

exports.roundEdgedBox = function (width, height, depth, radius, widthSegments, heightSegments, depthSegments, smoothness) {
  width = width || 1;
  height = height || 1;
  depth = depth || 1;
  radius = radius || Math.min(Math.min(width, height), depth) * .25;
  widthSegments = widthSegments ? Math.floor(widthSegments) : 1;
  heightSegments = heightSegments ? Math.floor(heightSegments) : 1;
  depthSegments = depthSegments ? Math.floor(depthSegments) : 1;
  smoothness = smoothness ? Math.max(3, Math.floor(smoothness) || 3) : 3;
  var halfWidth = width * .5 - radius;
  var halfHeight = height * .5 - radius;
  var halfDepth = depth * .5 - radius;
  var geometry = new THREE.Geometry(); // corners - 4 eighths of a sphere

  var corner1 = new THREE.SphereGeometry(radius, smoothness, smoothness, 0, Math.PI * .5, 0, Math.PI * .5);
  corner1.translate(-halfWidth, halfHeight, halfDepth);
  var corner2 = new THREE.SphereGeometry(radius, smoothness, smoothness, Math.PI * .5, Math.PI * .5, 0, Math.PI * .5);
  corner2.translate(halfWidth, halfHeight, halfDepth);
  var corner3 = new THREE.SphereGeometry(radius, smoothness, smoothness, 0, Math.PI * .5, Math.PI * .5, Math.PI * .5);
  corner3.translate(-halfWidth, -halfHeight, halfDepth);
  var corner4 = new THREE.SphereGeometry(radius, smoothness, smoothness, Math.PI * .5, Math.PI * .5, Math.PI * .5, Math.PI * .5);
  corner4.translate(halfWidth, -halfHeight, halfDepth);
  geometry.merge(corner1);
  geometry.merge(corner2);
  geometry.merge(corner3);
  geometry.merge(corner4); // edges - 2 fourths for each dimension
  // width

  var edge = new THREE.CylinderGeometry(radius, radius, width - radius * 2, smoothness, widthSegments, true, 0, Math.PI * .5);
  edge.rotateZ(Math.PI * .5);
  edge.translate(0, halfHeight, halfDepth);
  var edge2 = new THREE.CylinderGeometry(radius, radius, width - radius * 2, smoothness, widthSegments, true, Math.PI * 1.5, Math.PI * .5);
  edge2.rotateZ(Math.PI * .5);
  edge2.translate(0, -halfHeight, halfDepth); // height

  var edge3 = new THREE.CylinderGeometry(radius, radius, height - radius * 2, smoothness, heightSegments, true, 0, Math.PI * .5);
  edge3.translate(halfWidth, 0, halfDepth);
  var edge4 = new THREE.CylinderGeometry(radius, radius, height - radius * 2, smoothness, heightSegments, true, Math.PI * 1.5, Math.PI * .5);
  edge4.translate(-halfWidth, 0, halfDepth); // depth

  var edge5 = new THREE.CylinderGeometry(radius, radius, depth - radius * 2, smoothness, depthSegments, true, 0, Math.PI * .5);
  edge5.rotateX(-Math.PI * .5);
  edge5.translate(halfWidth, halfHeight, 0);
  var edge6 = new THREE.CylinderGeometry(radius, radius, depth - radius * 2, smoothness, depthSegments, true, Math.PI * .5, Math.PI * .5);
  edge6.rotateX(-Math.PI * .5);
  edge6.translate(halfWidth, -halfHeight, 0);
  edge.merge(edge2);
  edge.merge(edge3);
  edge.merge(edge4);
  edge.merge(edge5);
  edge.merge(edge6); // sides
  // front

  var side = new THREE.PlaneGeometry(width - radius * 2, height - radius * 2, widthSegments, heightSegments);
  side.translate(0, 0, depth * .5); // right

  var side2 = new THREE.PlaneGeometry(depth - radius * 2, height - radius * 2, depthSegments, heightSegments);
  side2.rotateY(Math.PI * .5);
  side2.translate(width * .5, 0, 0);
  side.merge(side2);
  geometry.merge(edge);
  geometry.merge(side); // duplicate and flip

  var secondHalf = geometry.clone();
  secondHalf.rotateY(Math.PI);
  geometry.merge(secondHalf); // top

  var top = new THREE.PlaneGeometry(width - radius * 2, depth - radius * 2, widthSegments, depthSegments);
  top.rotateX(-Math.PI * .5);
  top.translate(0, height * .5, 0); // bottom

  var bottom = new THREE.PlaneGeometry(width - radius * 2, depth - radius * 2, widthSegments, depthSegments);
  bottom.rotateX(Math.PI * .5);
  bottom.translate(0, -height * .5, 0);
  geometry.merge(top);
  geometry.merge(bottom);
  geometry.mergeVertices();
  return geometry;
};

exports.adjustTextureMapping = function (geometry) {
  var scaleX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var scaleY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  geometry.faceVertexUvs[0] = [];
  geometry.faces.forEach(function (face) {
    var v1 = geometry.vertices[face.a];
    var v2 = geometry.vertices[face.b];
    var v3 = geometry.vertices[face.c];
    var n = face.normal;
    var myNormalObject = {
      x: n.x,
      y: n.y,
      z: n.z
    }; // convert object into array

    var sortable = [];

    for (var key in myNormalObject) {
      if (myNormalObject.hasOwnProperty(key)) {
        sortable.push([key, myNormalObject[key]]);
      }
    }

    sortable.sort(function (a, b) {
      return Math.abs(a[1]) - Math.abs(b[1]);
    });

    if (sortable[0][0] === 'x' && sortable[1][0] === 'y') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.x / scaleX, v1.y / scaleY), new THREE.Vector2(v2.x / scaleX, v2.y / scaleY), new THREE.Vector2(v3.x / scaleX, v3.y / scaleY)]);
    }

    if (sortable[0][0] === 'y' && sortable[1][0] === 'x') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.y / scaleX, v1.x / scaleY), new THREE.Vector2(v2.y / scaleX, v2.x / scaleY), new THREE.Vector2(v3.y / scaleX, v3.x / scaleY)]);
    }

    if (sortable[0][0] === 'y' && sortable[1][0] === 'z') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.y / scaleX, v1.z / scaleY), new THREE.Vector2(v2.y / scaleX, v2.z / scaleY), new THREE.Vector2(v3.y / scaleX, v3.z / scaleY)]);
    }

    if (sortable[0][0] === 'z' && sortable[1][0] === 'y') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.z / scaleX, v1.y / scaleY), new THREE.Vector2(v2.z / scaleX, v2.y / scaleY), new THREE.Vector2(v3.z / scaleX, v3.y / scaleY)]);
    }

    if (sortable[0][0] === 'x' && sortable[1][0] === 'z') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.x / scaleX, v1.z / scaleY), new THREE.Vector2(v2.x / scaleX, v2.z / scaleY), new THREE.Vector2(v3.x / scaleX, v3.z / scaleY)]);
    }

    if (sortable[0][0] === 'z' && sortable[1][0] === 'x') {
      geometry.faceVertexUvs[0].push([new THREE.Vector2(v1.z / scaleX, v1.x / scaleY), new THREE.Vector2(v2.z / scaleX, v2.x / scaleY), new THREE.Vector2(v3.z / scaleX, v3.x / scaleY)]);
    }
  });
};

exports.mergeMeshes = function (mesh1, mesh2) {
  // Merging meshes makes the position relative to the target mesh, ugh...
  mesh2.position.x = mesh2.position.x - mesh1.position.x;
  mesh2.position.y = mesh2.position.y - mesh1.position.y;
  mesh2.position.z = mesh2.position.z - mesh1.position.z;
  mesh2.updateMatrix(); // Have to update matrix after changing position

  mesh1.geometry.merge(mesh2.geometry, mesh2.matrix);
  return mesh1;
};